import React from 'react';
import { TimerMode } from '../../../const/timer';
import { ChgkTimerWidget } from './ChgkTimer';

const TimerWidgetDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-16">
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid gap-4 lg:grid-cols-[1fr_360px]">
          <article className="rounded-2xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 p-6 shadow-sm">
            <h1 className="text-2xl font-black text-gray-900 dark:text-gray-50">NHN Taymer Vidceti (Daxili)</h1>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
              Bu blok moderator panelində taymerin səhifəyə daxili şəkildə yerləşdirilməsini göstərir.
              Davranış tam ekran rejimi ilə eynidir, yalnız düzülüş fərqlənir.
            </p>
            <div className="mt-5 rounded-xl border border-dashed border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-950 p-4 text-sm text-gray-500 dark:text-gray-400">
              İnteqrasiya: <code>{'<ChgkTimerWidget />'}</code> komponentini istənilən səhifəyə əlavə edin
              və oyun vəziyyəti ilə sinxron üçün callback-ləri ötürün.
            </div>
          </article>

          <ChgkTimerWidget
            title="Taymer Vidceti"
            initialMode={TimerMode.QUESTION}
            durations={{
              questionSeconds: 60,
              dupletSeconds: 30,
              blitzSeconds: 20,
              blitzSteps: 3,
            }}
            enableKeyboardShortcuts={false}
            enableSoundCue
          />
        </div>
      </div>
    </div>
  );
};

export default TimerWidgetDemo;
